import React from "react"
import {
  actualiteImage,
  actualiteFooter,
  actualiteImg,
  actualiteCategorie,
  actualiteTitle,
  actualiteResume,
  actualiteDate,
} from "../styles/listActus.module.scss"
import {
  summaryLength,
  coverSpeed,
} from "gatsby-theme-lantana/src/gatsby-theme-cactus/gatsby-theme-blank/constants"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import SummaryTransformer from "gatsby-theme-blank/src/components/Transformers/summary-transformer"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import {
  ActualiteTitle,
  ActualiteImage,
  ActualiteCategorie,
  ActualiteFooter,
  ActualiteResume,
} from "./styled-components/actualite-item-styled"
import PropTypes from "prop-types"

const ActualiteItem = ({ actu, colors }) => (
  <>
    <ActualiteImage className={actualiteImage}>
      {actu.relationships.field_image_actus?.localFile && (
        <TransitionFade
          arialabel="Lien vers l'actualité"
          link={actu.path.alias}
        >
          <NonStretchedImage
            className={actualiteImg}
            {...actu.relationships.field_image_actus?.localFile}
          />
        </TransitionFade>
      )}
    </ActualiteImage>
    {actu.relationships.field_taxonomie_thematique?.length > 0 && (
      <ActualiteCategorie className={actualiteCategorie}>
        <AniLink
          cover
          direction="down"
          bg={colors.b_color_gradients.b_dark}
          duration={coverSpeed}
          to={actu.relationships.field_taxonomie_thematique[0].path.alias}
        >
          {actu.relationships.field_taxonomie_thematique[0].name}
        </AniLink>
      </ActualiteCategorie>
    )}
    <ActualiteTitle className={actualiteTitle}>
      <TransitionFade link={actu.path.alias}>{actu.title}</TransitionFade>
    </ActualiteTitle>
    <ActualiteResume className={actualiteResume}>
      {actu.body && (
        <p
          dangerouslySetInnerHTML={{
            __html: SummaryTransformer(actu.body, summaryLength),
          }}
        />
      )}
    </ActualiteResume>
    <ActualiteFooter className={actualiteFooter}>
      <span className={actualiteDate}>{actu.created}</span>
    </ActualiteFooter>
  </>
)

ActualiteItem.propTypes = {
  actu: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

export default ActualiteItem
